export function PromptSourceBlocks({
  prompt,
  blocks,
}: {
  prompt: string;
  blocks?: Array<{ source: string; text: string }> | undefined;
}) {
  if (
    !blocks?.length ||
    blocks.map((block) => block.text).join("") !== prompt
  ) {
    return <>{prompt}</>;
  }
  return (
    <div className="prompt-source-blocks">
      {blocks.map((block, index) => (
        <section className="prompt-source-block" key={index}>
          <h3>
            <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
            {block.source}
          </h3>
          <div className="prompt-source-content">{block.text.trim()}</div>
        </section>
      ))}
    </div>
  );
}
